import React from 'react';
import { connect } from 'react-redux';
import { browserHistory } from 'react-router';
import { bindActionCreators } from 'redux';

//Actions
import * as appActions from '../actions/appActions';
import * as companiesActions from '../actions/companiesActions';

class ManageCompanies extends React.Component {
    constructor(props) {
        super(props);
        this.props.actions.getCompanies();
	}

    render() {
        const { isLoggedIn, isSuperUser, isAdmin } = this.props.userState;
        if (!(isLoggedIn && (isSuperUser || isAdmin))) return false;

        let markets = this.props.companies.data;

        return (
            <div>
                <h1>Companies</h1>

                {markets && markets.length ? markets.map( (item, i) => {
                    return item.companies && item.companies.length ?
                        <div key={'market_section_'+item.id}
                            className='market_companies_section'>

                            <h3>{item.name}</h3>
                            <MarketSection
                                actions={this.props.actions}
                                companies={item.companies} />
                        </div>
                    : '';
                }) : ''}
            </div>
        )
    }
}

class MarketSection extends React.Component {
    renderCompanySection(data) {
        const { showPopup, showUserPopup, updateCompanyAccess, 
            deleteCompany, getCompanies } = this.props.actions;

        if(data.length) {
            return data.map( item =>
                <CompanyRow
                    name={item.name}
                    web={item.web}
                    id={item.id}
                    approved={item.approved}
                    subscribed={item.approved_for_notifications}
                    key={'company_row_'+item.id}
                    showPopup={showPopup}
                    showUserPopup={showUserPopup}
                    updateCompanyAccess={updateCompanyAccess}
                    deleteCompany={deleteCompany}
                    refreshCompanies={getCompanies}
                />);
        }
    }

    render() {
        let { companies } = this.props;
        let needApproval = [], approved = [];

        companies.map( item => {
            if (item.approved == null && !item.approved_for_notifications) {
                needApproval.push(item);
            } else {
                approved.push(item)
            }
        })
        return (
            <div>
                <div className='company-row company-row-header'>
                    <div className='title-header'>Company name</div>
                    <span className='link-header'>Website</span>
                    <div className='radio-header'>
                      <div className='sub-column-holder legend'>
                        <div className='sub-column al'>Approved</div>
                        <div className='sub-column ac'>Only email notifications</div>
                        <div className='sub-column ar'>Blocked</div>
                      </div>
                    </div>
                </div>
                {this.renderCompanySection(needApproval)}
                {this.renderCompanySection(approved)}
            </div>
        )
    }
}

const CompanyRow = props => (
  <div className='company-row'>
        <div className='title' onClick={()=>props.showUserPopup(props.id)}>{props.name}</div>
        { props.web ?
            <a className='link' href={'http://'+props.web} target='_blank' title={'Go to ' + props.web}>{props.web}</a>
        : 
            <span className='link no-pointer'>-</span>
        }
        <RadioSection
            updateCompanyAccess={props.updateCompanyAccess}
            approved={props.approved}
            subscribed={props.subscribed}
            showPopup={props.showPopup}
            id={props.id} />
        <div
            onClick={() => props.deleteCompany(props.id, props.name, props.refreshCompanies)}
            className='delete'>delete</div>
  </div>
);

class RadioSection extends React.Component {

    constructor(props) {
        super(props);

        this.state = { option: '' }
        this._onChange = this._onChange.bind(this);
    }

    componentDidMount() {
        let { approved, subscribed } = this.props,
        status = '';

        if (approved == true) status = 'approve';
        if (approved == false) status = 'block';
        if (subscribed == true) status = 'subscribe';

        this.setState({ option: status });
    }

    _onChange(e) {
        let { value } = e.target;

        const updateAccess = () => {
            this.setState({
                option: value
            }, () => this.props.updateCompanyAccess(this.props.id, value));
        }

        if (value == 'approve') {
            this.props.showPopup({
                title: 'Approving company',
                content: 'When you approve this company, all associated users may receive an email to reset their password. Do you want to continue?',
                isConfirm: true,
                buttonAction: updateAccess
            });
        } else {
            updateAccess();
        }

    };

	render() {
		return (
            <div className='radio-holder'>
                <div className={'sub-column-holder '+(!this.state.option ? 'need-attention' : '')}>
                  <div className='sub-column'>
                      <input type='radio' value='approve' checked={this.state.option=='approve'} onChange={this._onChange} />
                  </div>
                  <div className='sub-column'>
                      <input type='radio' value='subscribe' checked={this.state.option=='subscribe'} onChange={this._onChange} />
                  </div>
                  <div className='sub-column'>
                      <input type='radio' value='block' checked={this.state.option =='block'} onChange={this._onChange} />
                  </div>
                </div>
            </div>
		)
	}
}



export default connect(
    state => ({
        companies: state.companies,
        userState: state.user,
    }),
    dispatch => ({
        actions: bindActionCreators({...appActions, ...companiesActions}, dispatch)
    })
)(ManageCompanies);



// WEBPACK FOOTER //
// ./source/screens/ManageCompanies.js